export default "__VITE_ASSET__BBtM33av__"